import { FiPhoneCall } from "react-icons/fi";
import { MdOutlineEmail } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../config";
import * as Yup from "yup";
import axios from "axios";
import { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from "formik";

const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    mobileNumber: Yup.string().required("Mobile Number is required"),
    emailId: Yup.string().required("Email Id is required"),
    message: Yup.string().required("Message is required"),
});

function Contact() {
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values, { resetForm }) => {
        setLoading(true);

        const payload = {
            ...values,
        };
        try {
            const response = await axios.post(`${BASE_URL}/form/contact`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.status === 200) {
                resetForm();
                toast.success("Submitted Successfully")
            } else {
                toast.error('Failed to submit the form, please try again.');
            }
        } catch (error) {
            if (error.response.data.status === 409) {
                toast.error(error.response.data.message)
            } else {
                toast.error("An error occurred while submitting the form. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="contact-four py-190 rpy-100" id="contact">
                <div className="container">
                    <div className="contact-inner-four box-shadow p-15 rpx-25 br-5 bg-white">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="contact-section-form px-15 rpx-0 rmb-50 wow fadeInUp delay-0-2s">
                                    <div className="section-title mb-20">
                                        <h2>Get In Touch</h2>
                                    </div>
                                    <div id="form-messages"></div>
                                    <Formik
                                        initialValues={{
                                            name: '',
                                            emailId: '',
                                            message: '',
                                            mobileNumber: ''
                                        }}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                    >
                                        {({ setFieldValue, values, isSubmitting }) => (
                                            <Form>
                                                <div className="row">
                                                    <div className="col-sm-12 col-12">
                                                        <div className="form-group">
                                                            <label htmlFor="name">Your name</label>
                                                            <Field className="contact__form--input__field" placeholder="Enter Your Name*"
                                                                type="text" name="name" id="name" />
                                                            <ErrorMessage name="name" component="div" className="error-message text-danger" />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-12">
                                                        <div className="form-group">
                                                            <label htmlFor="email">Your email address</label>
                                                            <Field className="contact__form--input__field" placeholder="Enter Email Address*"
                                                                type="email" name="emailId" id="email" />
                                                            <ErrorMessage name="emailId" component="div" className="error-message text-danger" />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-12">
                                                        <div className="form-group">
                                                            <label htmlFor="phone_Number">Your phone number</label>
                                                            <Field className="contact__form--input__field" placeholder="Enter Phone Number"
                                                                type="text" name="mobileNumber" id="phone_Number" />
                                                            <ErrorMessage name="mobileNumber" component="div" className="error-message text-danger" />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-12">
                                                        <div className="form-group">
                                                            <label htmlFor="message">Message</label>
                                                            <Field className="contact__form--textarea__field"
                                                                placeholder="Enter Your Message here" rows="4" name="message"
                                                                id="message" />
                                                            <ErrorMessage name="message" component="div" className="error-message text-danger" />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12">
                                                        <button
                                                            type="submit" id="submit-btn"
                                                            className="theme-btn"
                                                            disabled={isSubmitting || loading}
                                                        >
                                                            Send
                                                            Message</button>
                                                    </div>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                                
                            </div>
                            <div className="col-lg-5 p-0">
                                    <div className="contact-image-number style-two bgs-cover overlay wow fadeInUp delay-0-4s"
                                        style={{ backgroundImage: 'url(assets/images/contact/home-two.jpg)' }}>
                                        <div className="contact-informations text-white">
                                            <h3>Don't hesitate to contact us</h3>
                                            <ul className="contact-info">
                                                <li>
                                                    <i><FiPhoneCall /></i>
                                                    <div className="content">
                                                        <span>Call Us</span>
                                                        <h5><a href="tel:+918248646013">+91-8248-646-013</a></h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <i><MdOutlineEmail /></i>
                                                    <div className="content">
                                                        <span>Write to Us</span>
                                                        <h5><a href="mailto:maposithiru@gmail.com">maposithiru@gmail.com</a></h5>
                                                    </div>
                                                </li>
                                                <li>
                                                    <i><SlLocationPin /></i>
                                                    <div className="content">
                                                        <span>Address</span>
                                                        <h5>17/2, SENIAMMAN KOIL STREET,<br />TONDIARPET,<br />CHENNAI - 600081.</h5>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact;